module.exports = __webpack_public_path__ + "media/img/patterns/grid-vertical-ttb-dark-6ecf8ae7d2c2cba287c457304e23db23.png";